import { render, staticRenderFns } from "./FormPage4.vue?vue&type=template&id=679be2d8&scoped=true&"
import script from "./FormPage4.vue?vue&type=script&lang=js&"
export * from "./FormPage4.vue?vue&type=script&lang=js&"
import style0 from "./FormPage4.vue?vue&type=style&index=0&id=679be2d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679be2d8",
  null
  
)

export default component.exports